export const SPACING_KEYS = [
  "default",
  "giant",
  "huge",
  "large",
  "big",
  "small",
  "extraSmall",
  "sticky",
] as const

export type SpacingBase = (typeof SPACING_KEYS)[number]

export type OffsetUnitTypeBreakpoints = {
  small: number
  medium: number
  large: number
}

// HEL space units (1 unit = 8px). Ported verbatim from
// `@onestore/hel/dist/components/organisms/SectionOrg/SectionOrg.settings.js`
// (`spacingSpace`) so BaseSection/BaseContainer no longer import it at
// runtime — this table is the source of truth for both components' padding
// and negative-margin math.
export const SPACING_SPACE: Record<
  SpacingBase,
  { small: number; medium: number; large: number } | number
> = {
  giant: { small: 16, medium: 16, large: 30 },
  huge: { small: 8, medium: 12, large: 30 },
  large: { small: 8, medium: 12, large: 25 },
  big: { small: 8, medium: 12, large: 15 },
  default: { small: 6, medium: 8, large: 10 },
  small: { small: 3, medium: 4, large: 5 },
  extraSmall: { small: 3, medium: 3, large: 3 },
  sticky: 0,
}
